import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import Comunicados from './pages/Comunicados';
import Reclamacoes from './pages/Reclamacoes';
import GerenciarMoradores from './pages/GerenciarMoradores';
import AcaoEmail from './pages/AcaoEmail'; // Importe o componente correto
import Documentos from './pages/Documentos';
import GerenciarPrestadores from './pages/GerenciarPrestadores';
import GerenciarAreas from './pages/GerenciarAreas';
import ReservarAreas from './pages/ReservarAreas'; // Corrigido para remover importação duplicada
import ControleAcesso from './pages/ControleAcesso';
import GerenciarFuncionarios from './pages/GerenciarFuncionarios';
import GerenciarPonto from './pages/GerenciarPonto';
import ResponderCotacao from './pages/ResponderCotacao';
import ControlePonto from './pages/ControlePonto';
import ControleEstoque from './pages/ControleEstoque';
import Financeiro from './pages/Financeiro';
import ProtectedRoute from './components/ProtectedRoute';
import GerenciarCondominios from './pages/GerenciarCondominios';
import GerenciarFornecedores from './pages/GerenciarFornecedores';

import GerenciarCotacoes from './pages/GerenciarCotacoes';
import GerenciarOrdens from './pages/GerenciarOrdens';

const AppLayout = ({ children }) => {
  const location = useLocation();
  const noLayoutRoutes = ['/', '/completar-cadastro'];

  if (noLayoutRoutes.includes(location.pathname) || location.pathname.startsWith('/cotacao/')) {
    return <>{children}</>;
  }

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1, p: 2, width: { sm: `calc(100% - 240px)` } }}>
        {/* Spacer to push content down below the AppBar on mobile */}
        <Box sx={{ display: { xs: 'block', sm: 'none' }, minHeight: '64px' }} />
        {children}
      </Box>
    </Box>
  );
};

function App() {
  return (
    <Router>
      <AppLayout>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/completar-cadastro" element={<AcaoEmail />} />
          <Route path="/cotacao/:token" element={<ResponderCotacao />} />
          <Route
            path="/dashboard"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro', 'morador', 'zelador']}><Dashboard /></ProtectedRoute>}
          />
          <Route
            path="/comunicados"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro', 'morador', 'zelador']}><Comunicados /></ProtectedRoute>}
          />
          <Route
            path="/reclamacoes"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro', 'morador', 'zelador']}><Reclamacoes /></ProtectedRoute>}
          />
          <Route
            path="/gerenciar-moradores"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro', 'zelador']}><GerenciarMoradores /></ProtectedRoute>}
          />
          <Route
            path="/documentos"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro']}><Documentos /></ProtectedRoute>}
          />
          <Route
            path="/gerenciar-areas"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro', 'zelador']}><GerenciarAreas /></ProtectedRoute>}
          />
          <Route
            path="/meus-prestadores"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro', 'morador']}><GerenciarPrestadores /></ProtectedRoute>}
          />
          <Route
            path="/reservar-areas"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro', 'morador']}><ReservarAreas /></ProtectedRoute>}
          />
          <Route
            path="/gerenciar-funcionarios"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro']}><GerenciarFuncionarios /></ProtectedRoute>}
          />
          <Route
            path="/controle-ponto"
            element={<ProtectedRoute allowedRoles={['funcionario', 'zelador']}><ControlePonto /></ProtectedRoute>}
          />
          <Route path="/controle-acesso" element={
            <ProtectedRoute allowedRoles={['funcionario', 'zelador']}>
              <ControleAcesso />
            </ProtectedRoute>
          } />
          <Route path="/gerenciar-condominios" element={
            <ProtectedRoute allowedRoles={['admin_sistema']}>
              <GerenciarCondominios />
            </ProtectedRoute>
          } />
          <Route path="/gerenciar-fornecedores" element={
            <ProtectedRoute allowedRoles={['admin_sistema']}>
              <GerenciarFornecedores />
            </ProtectedRoute>
          } />
          <Route path="/gerenciar-cotacoes" element={
            <ProtectedRoute allowedRoles={['admin_sistema', 'administradora', 'sindico']}>
              <GerenciarCotacoes />
            </ProtectedRoute>
          } />
          <Route path="/gerenciar-ordens" element={
            <ProtectedRoute allowedRoles={['admin_sistema', 'administradora', 'sindico', 'zelador']}>
              <GerenciarOrdens />
            </ProtectedRoute>
          } />
          <Route
            path="/gerenciar-ponto"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro']}><GerenciarPonto /></ProtectedRoute>}
          />
          <Route
            path="/controle-estoque"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro', 'funcionario', 'zelador', 'administradora']}><ControleEstoque /></ProtectedRoute>}
          />
          <Route
            path="/financeiro"
            element={<ProtectedRoute allowedRoles={['sindico', 'sub_sindico', 'conselheiro']}><Financeiro /></ProtectedRoute>}
          />
        </Routes>
      </AppLayout>
    </Router>
  );
}

export default App;